import { i18n } from '../../i18n/i18n';

const state = {
  showModal: false,
  component: null,
  data: null,
  loading: false,
  options: {},
  defaults: {
    title: i18n.t('MODAL'),
    onSave: null,
    onCancel: null,
  },
};

const actions = {
  showModal({ commit }, { component, data, options }) {
    commit('modalShow', { component, data, options });
  },
  hideModal({ commit }) {
    commit('modalHide');
  },
  loadingModal({ commit }, loading) {
    commit('setLoader', loading === true);
  },
  saveModal({ commit, state }) {
    if (state.options.onSave) {
      state.options.onSave();
    }
    commit('modalHide');
  },
  cancelModal({ commit, state }) {
    if (state.options.onCancel) {
      state.options.onCancel();
    }
    commit('modalHide');
  },
};

const mutations = {
  modalShow(state, { component, data, options }) {
    state.showModal = true;
    state.component = component;
    state.data = data || null;
    state.options = { ...state.defaults, ...options };
    state.loading = false;
  },
  modalHide(state) {
    state.showModal = false;
    state.component = null;
    state.data = null;
    state.options = {};
    state.loading = false;
  },
  setLoader(state, loading) {
    state.loading = loading;
  },
};

export const modal = {
  namespaced: true,
  state,
  actions,
  mutations,
};
